import Coffee from './Coffee';
import Tea from './Tea';

var oCoffee = new Coffee();
oCoffee.prepareRecipe();
console.log("*********************************************************");
var oTea = new Tea();
oTea.prepareRecipe();
